"use strict";

exports.__esModule = true;
exports.dateFnsLocaleKeyMapping = void 0;
/**
 * Maps the app's Moment-style locale keys (see `dynamicMomentLocaleImports.js`) to the
 * locale codes date-fns v2 ships under `date-fns/locale/<code>`. Blueprint v6's date pickers
 * accept a `locale` string and dynamically `import("date-fns/locale/${code}")` it themselves
 * (see @blueprintjs/datetime's `DateFnsLocaleProps`), replacing the old `react-day-picker@7`
 * `localeUtils`/`locale` combo used pre-Blueprint-v6.
 */
var dateFnsLocaleKeyMapping = exports.dateFnsLocaleKeyMapping = {
  "de-de": "de",
  "es-es": "es",
  "fi-FI": "fi",
  "fr-fr": "fr",
  "it-it": "it",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "pl-pl": "pl",
  "pt-PT": "pt",
  "hu-hu": "hu",
  "pt-BR": "pt-BR",
  "zh-cn": "zh-CN",
  "en-us": "en-US"
};